export default "__VITE_ASSET__CT6$nxU3__"